import { PageHeader } from "@/widgets/page-header"
import { InvoicesTable } from "./invoices-table"
import { useEffect } from "react"
import { fetchInvoices, selectInvoicesFirstLoad } from "@/entities/invoice"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageSubtitle } from "@/shared/ui/page-subtitle"

export const InvoicesPage = () => {
    const dispatch = useAppDispatch()
    const invoicesFirstLoad = useAppSelector(selectInvoicesFirstLoad)

    useEffect(() => {
        if (invoicesFirstLoad) {
            dispatch(fetchInvoices())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Счета" />
            <div className="flexbox">
                <PageSubtitle title="список счетов" />
                <InvoicesTable />
            </div>
        </div>
    )
}